import { isValid as isDateTimeValid, format } from "date-fns";
import appConstants from "../../../../../../appConstants";
import { postData } from "../../../../../../api/componentAPIs";

const formatDateTime = (dateTimeString) => {
  if (!dateTimeString || !isDateTimeValid(dateTimeString)) {
    return "";
  }
  const date = format(dateTimeString, appConstants.DATETYPES.MONTHDATEYEAR.format);
  const time = format(dateTimeString, appConstants.DATETYPES.TIME.format);
  return `${date} | ${time}`;
};

const formatTime = (dateTimeString) => {
   if (!dateTimeString || !isDateTimeValid(dateTimeString)) {
     return "";
   }
   return format(dateTimeString, appConstants.DATETYPES.TIME.format);
}

const getPickupShipments = (pickupId, shipmentData) => {
  const pickup = shipmentData.find(
    (pickup) => pickup.pickupId.toUpperCase() === pickupId.toUpperCase()
  );
  return pickup ? pickup.shipments : [];
};


const getPickupShipmentList = ({
  terminalCode,
  pickupId,
  shipmentInfo,
  isPastPickup,
  pickupNumber,
  shipmentAPI,
  pastPickupShipments,
}) => {
  if (!shipmentAPI) {
    return Promise.resolve({ data: pastPickupShipments ?? [], gridStatus: appConstants.GRID_STATUS.SUCCESS });
  }
  if (shipmentInfo.gridStatus !== appConstants.GRID_STATUS.LOADING) {
    return Promise.resolve({ data: [], gridStatus: appConstants.GRID_STATUS.LOADING });
  }
  const params = isPastPickup
    ? {
        terminalCode,
        pickupNumber: pickupNumber
      }
    : {
        terminalCode,
        pickupIds: [pickupId]
      };
  return postData(shipmentAPI, params).then(
    (response) => {
      if (response && response.status === 200) {
        return {
          data: isPastPickup ? response.data : getPickupShipments(pickupId, response.data),
          gridStatus: appConstants.GRID_STATUS.SUCCESS
        };
      }
      return { data: [], gridStatus: appConstants.GRID_STATUS.ERROR };
    },
    (error) => {
      return { data: [], gridStatus: appConstants.GRID_STATUS.ERROR };
    }
  );
};

const getFormattedPickupToggleInfo = (pickupInfo) => {
  return [
    { label: 'Is Exhibit Pickup', value: pickupInfo.isExhibitPickup ? 'Yes' : '' },
    { label: 'Is Pickup a Trailer Swap', value: pickupInfo.isSwapPickup ? 'Yes' : '' },
    { label: 'Is Pickup a Dock Drop', value: pickupInfo.isDockDropPickup ? 'Yes' : '' },
    { label: 'Is Lift Gate Required', value: pickupInfo.isLiftGate ? 'Yes' : '' },
    { label: 'Is Warehouse Pickup', value: pickupInfo.isWarehousePickup ? 'Yes' : '' },
    { label: 'Is Daily Pickup', value: pickupInfo.isDailyPickup ? 'Yes' : '' }
  ].filter((item) => item.value);
};

const getFormattedPickupStatusToggleInfo = (pickupInfo) => {
  return [
    { label: 'Shipper Load and Count', value: pickupInfo.isShipperLoadAndCount ? 'Yes' : '' },
    {
      label: 'Is driver allowed inside to complete pickup?',
      value: pickupInfo.isDriverAllowedInside ? 'Yes' : '',
      showColon: false
    }
  ].filter((item) => item.value);
};

const isUnassignedNoFreightPickup = (isNoFreight, driverNumber) => {
  return !driverNumber && isNoFreight;
}

export {
  formatDateTime,
  formatTime,
  getPickupShipmentList,
  getFormattedPickupToggleInfo,
  getFormattedPickupStatusToggleInfo,
  isUnassignedNoFreightPickup,
};
